import { useContext } from "react";
import { UserContext } from "../pages/UserContext";
import isTokenValid from "../utlities/auth.utility";
import isActiveAccount from "../utlities/accountStatus";
import { ACCESS_LEVEL_SUPER_USER } from "../utlities/core.constants";

/**
 * Whether the current user has full ACR Editor access: a valid session token and
 * an active vendor, agency (Buyer), or super-user account. Everyone else gets
 * Public Mode (download-only).
 *
 * Derived from `user` in this render. The role flags (`isVendorUser` and friends)
 * are written in an effect, so they are still false on the render that sets
 * `user`. Reading those flags here treats a just-restored session as Public Mode
 * for a frame and `applyPublicModeLifecycle` then rewrites the draft.
 */
export default function useEditorAccess() {
  const { token, user } = useContext(UserContext);
  if (!isTokenValid(token) || !isActiveAccount(user)) return false;
  return Boolean(
    user.vendorId || user.agencyId || user.accessLevel === ACCESS_LEVEL_SUPER_USER
  );
}
